<form [formGroup]="formGroup">
  <div class="flex flex-col md:flex-row gap-x-5">
    <div class="flex-1">
      <div class="x-input-label">
        {{ 'position_definer.latitude' | translate }}
      </div>
      <div>
        <tui-textfield tuiTextfieldSize="m">
          <input
            [formControlName]="FormFields.Latitude"
            placeholder="{{ 'position_definer.latitude_example' | translate }}"
            tuiInput
          />
        </tui-textfield>
      </div>
    </div>

    <div class="flex-1">
      <div class="x-input-label">
        {{ 'position_definer.longitude' | translate }}
      </div>
      <div>
        <tui-textfield tuiTextfieldSize="m">
          <input
            [formControlName]="FormFields.Longitude"
            placeholder="{{ 'position_definer.longitude_example' | translate }}"
            tuiInput
          />
        </tui-textfield>
      </div>
    </div>
  </div>

  <div class="flex flex-row gap-3 mt-5">
    <div class="flex flex-row gap-3 items-center">
      <input
        tuiCheckbox
        type="checkbox"
        [formControlName]="FormFields.IAmOnObjectPlace"
        size="m"
        class="flex-1"
      />
      <span class="text-sm">{{
        'position_definer.i_am_on_object_place' | translate
      }}</span>
    </div>
    <button
      tuiButton
      type="button"
      size="s"
      [disabled]="!iAmOnObjectPlace.value"
      (click)="detectPositionAuto$.next()"
      [class.cursor-not-allowed]="!iAmOnObjectPlace.value"
      class="flex-1 h-fit!"
    >
      <span class="py-1">{{
        'position_definer.auto_detect_position' | translate
      }}</span>
    </button>
  </div>

  @if (autoPositionSetStatus$ | async; as autoPositionSetStatus) {
    <div
      class="mt-5 text-sm"
      [class.x-text-primary]="autoPositionSetStatus.isSuccess"
      [class.text-(--tui-status-negative)]="!autoPositionSetStatus.isSuccess"
    >
      {{ autoPositionSetStatus.helpText }}
    </div>
  }

  <div class="flex justify-end mt-5 gap-5">
    <button
      tuiButton
      appearance="secondary"
      type="button"
      size="m"
      (click)="cancelForm()"
    >
      {{ 'position_definer.cancel' | translate }}
    </button>
    <button
      tuiButton
      type="button"
      size="m"
      (click)="saveForm()"
      [class.cursor-not-allowed]="formGroup.invalid"
      [class.cursor-pointer]="formGroup.valid"
      [disabled]="formGroup.invalid"
    >
      {{ 'position_definer.specify' | translate }}
    </button>
  </div>
</form>
